<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS SGTEC"
        subTitulo="APOIO"
        @click.native="$router.push({ name: 'Sgtec_Apoios_Pagamentos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
